import React, { useEffect, useCallback } from 'react';

import './ImmersivePopup.global.styl';

interface Props {
  children: React.ReactNode;
  onClose: () => void;
  visible: boolean;
  hideCloseIconBtn: boolean;
  allowEsc: boolean;
}

function ImmersivePopup({
  children,
  onClose,
  visible,
  hideCloseIconBtn,
  allowEsc,
}: Props) {
  const handleEscKeyDown = useCallback(
    event => {
      const ESCAPE_KEY_CODE = 27;
      if (
        event.keyCode === ESCAPE_KEY_CODE &&
        visible &&
        (!hideCloseIconBtn || allowEsc)
      ) {
        onClose();
      }
    },
    [visible, hideCloseIconBtn, allowEsc, onClose],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleEscKeyDown);
    return () => {
      document.removeEventListener('keydown', handleEscKeyDown);
    };
  }, [handleEscKeyDown]);

  return (
    <div className={`mio-immersive-popup ${visible ? 'visible' : ''}`}>
      <div className="mio-immersive-popup__content-wrapper">
        <div className="mio-immersive-popup__content">{children}</div>
      </div>
      {hideCloseIconBtn || (
        <i
          className="iconfont icon-delete mio-immersive-popup__close-button"
          onClick={onClose}
        />
      )}
    </div>
  );
}

ImmersivePopup.defaultProps = {
  children: undefined,
  onClose: () => {},
  visible: false,
  hideCloseIconBtn: false,
  allowEsc: false,
} as Partial<Props>;

export default ImmersivePopup;
